// Keep only the latest point; never retain a React SyntheticEvent.
export const createCanvasPointerScheduler = (
  processPoint,
  requestFrame = requestAnimationFrame,
  cancelFrame = cancelAnimationFrame,
) => {
  let frame = null;
  let pending = null;
  const flush = () => {
    if (frame !== null) cancelFrame(frame);
    frame = null;
    const point = pending;
    pending = null;
    if (point) processPoint(point);
  };
  return {
    queue(event) {
      pending = { clientX: event.clientX, clientY: event.clientY };
      if (frame === null) frame = requestFrame(flush);
    },
    flush,
    cancel() {
      if (frame !== null) cancelFrame(frame);
      frame = null;
      pending = null;
    },
  };
};
